
'use strict';

var FormView = require('./FormView');
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';

export function create($parent) {
  require('../../js/validators/index');
  parallelArrayEach($parent.find('.u-form'), (el) => new FormView({ el: el }));
}



// WEBPACK FOOTER //
// ./assets/components/Form/Form.js